import CommonService from '../services/common.service';

function mapCountries(apiCountries) {
  return (Array.isArray(apiCountries) ? apiCountries : [])
    .map((country) => {
      const id = country.country_id ?? country.id ?? country.value;
      const label =
        country.country_name ?? country.country_label ?? country.label ?? country.name ?? country.country;
      return { id, label };
    })
    .filter((c) => c.id != null && c.label);
}

function mapStates(apiStates) {
  return (Array.isArray(apiStates) ? apiStates : [])
    .map((state) => {
      const id = state.state_id ?? state.id ?? state.value;
      const label = state.state_name ?? state.state_label ?? state.label ?? state.name ?? state.state;
      return { id, label };
    })
    .filter((s) => s.id != null && s.label);
}

function mapCities(apiCities) {
  return (Array.isArray(apiCities) ? apiCities : [])
    .map((city) => {
      const id = city.city_id ?? city.id ?? city.value;
      const label = city.city_name ?? city.city_label ?? city.label ?? city.name ?? city.city;
      return { id, label };
    })
    .filter((c) => c.id != null && c.label);
}

export function looksLikeMasterLocationId(value) {
  if (value == null || String(value).trim() === '') return false;
  return /^\d+$/.test(String(value).trim());
}

function labelFromList(id, list) {
  if (id == null || String(id).trim() === '') return id;
  if (!looksLikeMasterLocationId(id)) return id;
  const sid = String(id).trim();
  const hit = list.find((row) => String(row.id) === sid);
  return hit?.label ?? id;
}

async function fetchCountries() {
  const response = await CommonService.get('/master/company-Country');
  if (!response?.success || !response?.data) return [];
  const raw = Array.isArray(response.data)
    ? response.data
    : response.data.countries || response.data.master_countries || [];
  return mapCountries(raw);
}

async function fetchStates(countryId) {
  if (!countryId) return [];
  const response = await CommonService.get(`/master/company-State/${countryId}`);
  if (!response?.success || !response?.data) return [];
  const raw = Array.isArray(response.data)
    ? response.data
    : response.data.states || response.data.master_states || [];
  return mapStates(raw);
}

async function fetchCities(stateId) {
  if (!stateId) return [];
  const response = await CommonService.get(`/master/company-City/${stateId}`);
  if (!response?.success || !response?.data) return [];
  const raw = Array.isArray(response.data)
    ? response.data
    : response.data.cities || response.data.master_cities || [];
  return mapCities(raw);
}

/** Resolve origin/destination country, state, city master IDs to display labels. */
export async function resolveLogisticsLocationFields(payload) {
  if (!payload || typeof payload !== 'object') return {};

  const out = {};
  try {
    const countries = await fetchCountries();
    out.originCountry = labelFromList(payload.originCountry, countries);
    out.destCountry = labelFromList(payload.destCountry, countries);

    const originStates =
      payload.originCountry && looksLikeMasterLocationId(payload.originCountry)
        ? await fetchStates(payload.originCountry)
        : [];
    out.originState = labelFromList(payload.originState, originStates);

    const destStates =
      payload.destCountry && looksLikeMasterLocationId(payload.destCountry)
        ? await fetchStates(payload.destCountry)
        : [];
    out.destState = labelFromList(payload.destState, destStates);

    const originCities =
      payload.originState && looksLikeMasterLocationId(payload.originState)
        ? await fetchCities(payload.originState)
        : [];
    out.originCity = labelFromList(payload.originCity, originCities);

    const destCities =
      payload.destState && looksLikeMasterLocationId(payload.destState)
        ? await fetchCities(payload.destState)
        : [];
    out.destCity = labelFromList(payload.destCity, destCities);
  } catch {
    /* keep raw values on failure */
  }
  return out;
}

export const LOGISTICS_LOCATION_FIELD_KEYS = [
  'originCountry',
  'originState',
  'originCity',
  'destCountry',
  'destState',
  'destCity',
];
